import { controls, grouped } from "../controls";
const assign_schools_to_users = {
    label: "Assign Schools To Users",
    pageLabel: "Assign Schools To Users", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    pageType: "history",
    bulk: { columns: ["school_id", "user_id"] },
    formTabs:
    {
        allTabs: [
            { label: "General", uid: "general" },
            { label: "Bulk", uid: "bulk" }
        ]
    },
    filter: [
    ]
    , form: [
        ...controls.displayText({ tab: "general", label: "School", star: false }),
        ...controls.oc({ tab: "general", c: "School", placeHolder: "School Code", name: "school_code", fastpath: "schools", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "school_display" }),
        ...controls.displayText({ tab: "general", label: "User", star: false }),
        ...controls.oc({ tab: "general", c: "User", placeHolder: "User Code", name: "user_code", fastpath: "users", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Assign Schools To Users",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "School Code", accessor: "AssignSchoolToUser-school-school_code", align: "center", width: 30 },
            { Header: "School Display", accessor: "AssignSchoolToUser-school-school_display", align: "center", width: 30 },
            { Header: "UserName", accessor: "AssignSchoolToUser-user-username", },
            { Header: "User Display", accessor: "AssignSchoolToUser-user-user_display", },
        ]
    }
};
export default assign_schools_to_users;